import { render } from "./EnforcementParticipantCard.vue?vue&type=template&id=0bb6889c&scoped=true"
import script from "./EnforcementParticipantCard.vue?vue&type=script&lang=js"
export * from "./EnforcementParticipantCard.vue?vue&type=script&lang=js"

import "./EnforcementParticipantCard.vue?vue&type=style&index=0&id=0bb6889c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb6889c"]])

export default __exports__